/**
 * Root layout: ThemeProvider + CssBaseline + AuthProvider + i18n + Outlet.
 * All authenticated child routes mount inside an AuthGate (see router.tsx).
 */
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useMemo } from 'react';
import { createAppTheme } from '@/theme/theme';
import { AuthProvider } from '@/auth/AuthContext';
// Side-effect: initializes i18next with bundled catalogs.
import '@/i18n/i18n';

export function RootLayout() {
  const theme = useMemo(() => createAppTheme(), []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    </ThemeProvider>
  );
}
